import React from "react";
import { NavLink } from "react-router-dom";
import { NAV } from "@/constants/testIds";
import {
  LayoutDashboard, Users, FileText, Send, Image as ImageIcon,
  Settings as SettingsIcon, ShieldCheck, GitBranch, HelpCircle,
} from "lucide-react";

const NAV_ITEMS = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard, testid: NAV.dashboard, end: true },
  { to: "/users", label: "Usuarios", icon: Users, testid: NAV.users },
  { to: "/templates", label: "Plantillas", icon: FileText, testid: NAV.templates },
  { to: "/assignments", label: "Asignaciones", icon: GitBranch, testid: NAV.assignments },
  { to: "/publish", label: "Publicar", icon: Send, testid: NAV.publish },
  { to: "/images", label: "Imágenes", icon: ImageIcon, testid: NAV.images },
  { to: "/audit", label: "Auditoría", icon: ShieldCheck, testid: NAV.audit },
  { to: "/settings", label: "Configuración", icon: SettingsIcon, testid: NAV.settings },
  { to: "/help", label: "Ayuda", icon: HelpCircle, testid: NAV.help, adminOnly: true },
];

const linkClass = ({ isActive }) => [
  "flex items-center gap-3 px-3 py-2 rounded-md text-sm transition-colors duration-150 border-l-4",
  isActive
    ? "bg-slate-50 border-orange-600 text-slate-900 font-medium"
    : "border-transparent text-slate-600 hover:text-slate-900 hover:bg-slate-50",
].join(" ");

function DemoModeCard() {
  return (
    <div className="p-3 mt-4 mx-3 rounded-md bg-orange-50 border border-orange-200">
      <div className="text-[11px] uppercase tracking-wider text-orange-700 font-semibold mb-1">Modo Demo</div>
      <p className="text-xs text-slate-700 leading-relaxed">
        Configure Microsoft Graph en Configuración para sincronizar usuarios reales.
      </p>
    </div>
  );
}

export function Sidebar({ isAdmin }) {
  const items = NAV_ITEMS.filter((item) => !item.adminOnly || isAdmin);
  return (
    <aside className="w-64 min-h-[calc(100vh-3.5rem)] bg-white border-r border-slate-200">
      <nav className="p-3 space-y-0.5">
        {items.map((item) => (
          <NavLink key={item.to} to={item.to} end={item.end} data-testid={item.testid} className={linkClass}>
            <item.icon className="w-4 h-4" strokeWidth={1.75} />
            <span>{item.label}</span>
          </NavLink>
        ))}
      </nav>
      <DemoModeCard />
    </aside>
  );
}
